import { useMemo } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { gameService } from '../services/gameService';
import { Game } from '../types';
import { useAuthStore } from '../store/authStore';

export function useGames() {
  return useQuery({ queryKey: ['games'], queryFn: gameService.list });
}

export function useGame(id: number) {
  return useQuery({
    queryKey: ['games', id],
    queryFn: () => gameService.getById(id),
    enabled: !!id,
  });
}

export function usePreferredGames() {
  const query = useGames();
  const user = useAuthStore((s) => s.user);
  const prefs = user?.game_preferences;

  const data = useMemo(() => {
    if (!query.data) return [];
    if (!prefs || prefs.length === 0) return query.data;
    return query.data.filter((g) => prefs.includes(g.id));
  }, [query.data, prefs]);

  return { ...query, data };
}

export function useCreateGame() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<Game>) => gameService.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['games'] }),
  });
}
